<template>
  <div>
    <class-remark
      :value="classRemarkDialog"
      @input="(value) => {classRemarkDialog = value}"
      v-model="
        classRemarkDialog"
    ></class-remark>
    <!-- <classRemarkTrial v-model="classRemarkTrialDialog"/> -->

    <class-remark2 :classRemarks2="classRemarks2"></class-remark2>

    <new-class-remark :newClassRemark="newClassRemark"></new-class-remark>
    <new-class-remark-trial :newClassRemarkTrial="newClassRemarkTrial"></new-class-remark-trial>
    <assistance v-model="openAssistance" :infoUsedAClassroom = "info.UsedAClassroom"></assistance>
    <singleAssistanceDialog v-model="openSingleAssistanceDialog"></singleAssistanceDialog>
    <lesson-plan :lessonPlan="lessonPlan" v-if="lessonPlan.dialog"></lesson-plan>
    <v-dialog
      v-model="overflowDialog.show"
      width="60em"
    >
      <v-card>
        <v-card-title class="title blue-title pa-3 pt-4 ml-2">{{overflowDialog.title}}</v-card-title>
        <v-card-text
          class="blue-title px-4"
          style="overflow-wrap: break-word;"
          v-html="overflowDialog.content"
        ></v-card-text>
        <v-card-actions class="pa-3">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-btn
                class="red-button dialog-submit"
                @click="overflowDialog.show = false"
              >OK</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div :class="`grid-table grid-table--${classStatus} grid-table-evaluate--${isPastLabelUser?classStatus:''}`">
      <v-layout class="class-id">
        <v-flex xs4>Class ID</v-flex>
        <v-flex xs8>
          {{info.CLID}}
          <span :class="info.isVip === 0? 'info-chip blue-chip' : 'info-chip red-chip ext-tag'">{{ info.isVip === 1? 'VIP' : 'TRIAL' }} {{info.ExtTagName ? '-' + info.ExtTagName : ''}}</span>
          <span v-if="info.IsClassTeacher==true" style="margin-left:25px">(Class Teacher)</span>
          <span v-if="info.Is20And5AICourse" style="margin-left:30px;">AI picture book class</span>
        </v-flex>
      </v-layout>
      <v-layout class="uid"> 
        <v-flex>Student UID</v-flex>
      </v-layout>
      <v-layout class="uid-content">
        <v-btn class="text-none blue-button" @click="studentInfo(info.StuUID,info.ClassTime,info.CLID)" v-if="info.IsExperimentStu">
        {{info.StuName}}
        <strong>({{info.StuUID}})</strong>
        </v-btn>
        <span v-else>
        {{info.StuName}}
        <strong>({{info.StuUID}})</strong>
        </span>
        <span v-if="info.UserBrandType" class="info-chip red-chip">{{ info.UserBrandType }}</span>

        <v-btn class="text-none AI-btn" :loading="AIDetailLoading" v-if="info.CessonAIEnergizeResult" @click="showAIDetail()">AI analysis</v-btn>
        
      </v-layout>
      <!-- <v-layout class="qq">
        <v-flex xs4>Student(QQ)</v-flex>
        <v-flex xs8>{{ info.Qq || "N/A" }}</v-flex>
      </v-layout> -->
      <v-layout class="skype">
        <v-flex>Student Skype</v-flex>
      </v-layout>
      <v-layout class="skype-content">{{ info.Skype || "N/A" }}</v-layout>
      <v-layout class="time">
        <v-flex xs4>Class Time </v-flex>
        <v-flex xs8>(UTC{{info.TeacherUTCOffset}}){{info.ClassTime | dateFileter('MM-DD-YYYY HH:mm')}}</v-flex>
      </v-layout> 
      <v-layout class="request" v-if="!isPastLabelUser">
        <v-flex>Students' Special request</v-flex>
      </v-layout>
      <v-layout class="request-content" v-if="!isPastLabelUser">
        <!-- 这里的需求是150个字的限制, 实际操作为限高6em -->
        <div
          class="request-content-items"
          v-if="info.StudentRequest && info.StudentRequest.length"
        >
          <!-- <div>
            <p
              :key="item.Title"
              v-for="(item) in info.StudentRequest"
            >{{item.Title ? (item.Title + ':') : ''}} {{item.Content }}</p>
          </div> -->

          <v-tooltip bottom content-class="info-table-tooltip">
            <template v-slot:activator="{ on }">
              <v-btn flat class="text-none " v-on="on">
                  <!-- <p  class="mb-0" :key="item.Title" v-for="(item) in info.StudentRequest">
                    {{item.Title ? (item.Title + ':') : ''}} {{item.Content }}<br/>
                  </p> -->
                  <p  class="mb-0 line-clamp-2" v-html="turnToString(info.StudentRequest)">
                  </p>
              </v-btn>
            </template>
            <span><p class="mb-0"
              :key="item.Title"
              v-for="(item) in info.StudentRequest"
            >{{item.Title ? (item.Title + ':') : ''}} {{item.Content }}</p></span>
        </v-tooltip>
        </div>
        
        <template v-else>N/A</template>
      </v-layout>
      <!-- 实验学生给老师的过往好评标签 -->
      <!-- <v-layout class="positive" v-if="isPastLabelUser">
        <v-flex xs12>
          <v-flex xs12 mb-3>Student’s Positive Review for Previous Teachers</v-flex>
          <v-flex xs12>
            <v-layout wrap v-if="PositiveList&&PositiveList.length">
              <v-flex xs12 mb-1 v-for="(item,i) in PositiveList" :key="i"><span>{{item.AppraisalItemInfoEN}}（{{item.Total}}）</span>
                <v-tooltip v-if="i==0" bottom content-class="commons-tooltip evaluate-tooltip" v-model="showSuggestTip">
                  <template v-slot:activator="{ on }">
                    <img :src="suggest" alt="" v-on="on" class="cursor-pointer" @click="openSuggestFile(item.RedirectUrl,item.Id)" style="vertical-align: middle" />
                  </template>
                  <span>{{item.Suggestion}}<br>
                    More tips on planning the lesson can be found here.</span>
                </v-tooltip>
                <v-tooltip v-else bottom content-class="commons-tooltip evaluate-tooltip">
                  <template v-slot:activator="{ on }">
                    <img :src="suggest" alt="" v-on="on" class="cursor-pointer" @click="openSuggestFile(item.RedirectUrl,item.Id)" style="vertical-align: middle" />
                  </template>
                  <span>{{item.Suggestion}}<br>
                    More tips on planning the lesson can be found here.</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <span v-else class="font-weight-regular">N/A</span>
          </v-flex>
        </v-flex>
      </v-layout> -->

      <v-layout class="tool">
        <v-flex xs4>Tutoring Tool</v-flex>
        <v-flex xs8>
          <class-tool-btn :ClassTools="this.info.ClassTools"></class-tool-btn>
        </v-flex>
      </v-layout>
      <v-layout class="intention" v-if="!isPastLabelUser">
        <v-flex>Students' Learning Intention</v-flex>
      </v-layout>
      <v-layout class="intention-content" v-if="!isPastLabelUser">
        <!-- <v-layout wrap> -->
          <!-- <v-flex xs12>{{ info.Intention || "N/A" }}</v-flex> -->
          <!-- <v-flex xs12> -->
            <!-- Notes:  -->
            <!-- {{ info.Csremark || "N/A" | textTruncate(150)}} -->
            <v-tooltip bottom content-class="info-table-tooltip" v-if="info.Csremark && info.Csremark.length> 20">
              <template v-slot:activator="{ on }">
                <v-btn flat
                    class="text-none" v-on="on"><p class="mb-0">{{ info.Intention || "N/A" }}</p><p class="mb-0">Notes: {{ info.Csremark || "N/A" | textTruncate(150)}}</p>
                </v-btn>
              </template>
              <span><p class="mb-0">{{ info.Intention || "N/A" }}</p><p class="mb-0">Notes: {{ info.Csremark }}</p></span>
            </v-tooltip>
            <v-layout wrap v-else>
              <v-flex xs12>{{ info.Intention || "N/A" }}</v-flex>
              <v-flex xs12>Notes: {{ info.Csremark || "N/A" | textTruncate(150)}}</v-flex>
            </v-layout>
          <!-- </v-flex> -->
        <!-- </v-layout> -->
      </v-layout>
      <!-- 实验学生给老师的过往差评标签 -->
      <!-- <v-layout class="negative" v-if="isPastLabelUser">
        <v-flex xs12>
          <v-flex xs12 mb-3>Student’s Negative Review for Previous Teachers</v-flex>
          <v-flex xs12>
            <v-layout wrap v-if="NegativeList&&NegativeList.length">
              <v-flex xs12 mb-1 v-for="(item,i) in NegativeList" :key="i"><span>{{item.AppraisalItemInfoEN}}（{{item.Total}}）</span>
                <v-tooltip bottom content-class="commons-tooltip evaluate-tooltip">
                  <template v-slot:activator="{ on }">
                    <img :src="suggest" alt="" v-on="on" class="cursor-pointer" @click="openSuggestFile(item.RedirectUrl,item.Id)" style="vertical-align: middle" />
                  </template>
                  <span>{{item.Suggestion}}<br>
                    More tips on planning the lesson can be found here.</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <span v-else class="font-weight-regular">N/A</span>
          </v-flex>
        </v-flex>
      </v-layout> -->

      <v-layout class="remark">
        <v-flex xs4>Class Remarks</v-flex>
        <v-flex xs8>
          <v-btn
            @click="EndClass()"
            class="text-none blue-button"
            v-if="info.ShowOverClassBtn"
            :loading="OverClassLoading"
          >Class Over</v-btn>
          <!-- 此处可能弹窗试课课程评价弹窗模板二,请添加 classRemarkTrialDialog 相关判断 -->
          <v-btn
            :color="`${(!info.ShowOverClassBtn && isCanOpen) ? 'deep-orange darken-2':'grey'}`"
            @click="OpenRemark()" :disabled = "(info.ShowOverClassBtn && !isCanOpen) ? true : false"
            class="text-none blue-button" :title="`${(info.ShowOverClassBtn && isCanOpen) ? '':'AI report is being generated. Please come back after 90 seconds for editing.'}`"
            dark
            v-if="info.AllowLeaveRemark===1"
          >Leave Class Remarks</v-btn>
          <v-btn
            @click="OpenRemark()" :disabled = "info.ShowOverClassBtn ? true : false"
            class="text-none"
            color="primary"
            v-if="info.AllowLeaveRemark===2"
          >
            √ Completed
            <v-icon
              right
              small
            >border_color</v-icon>
          </v-btn>
          <!-- <v-btn
            :color="`${info.ShowSameMaterialBtn? 'deep-orange darken-2':'grey'}`"
            @click="getSameMaterial"
            class="text-none"
            dark
            v-if="info.ShowSameMaterialBtn && !(info.AllowLeaveRemark===3&&info.LessonStatus===1)"
          >Same Material as Previous Class</v-btn> -->
          <div class="deep-orange--text text--darken-2">
            {{info.AllowLeaveRemark===-1 ? 'N/A': ''}}
            {{info.AllowLeaveRemark===-3 ? 'Student Missing': ''}}
            {{info.AllowLeaveRemark===3&&info.LessonStatus===1 ? 'Class Completed': ''}}
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="problem">
        <v-flex>Problems in class</v-flex>
      </v-layout>
      <v-layout class="problem-content">
        <v-btn
          @click="openAssistance = !openAssistance"
          class="text-none"
          color="error"
          dark
          v-if="!info.AllowLeaveCSRemark && isShow"
        >
          <v-icon
            dark
            left
          >cloud_upload</v-icon>CS Assistance
        </v-btn>
        <v-flex v-if="info.CircumstanceStatus>0 && isShow">
          <v-btn
            :ripple="false"
            @click="getAssistanceInfo()"
            class="text-none subheading mr-0 pr-2"
            falt
            flat
          >CS Assistance</v-btn>
          <v-icon
            @click="openImg"
            color="blue darken-2"
            v-if="info.AbsentPic"
          >image</v-icon>
          <a
            :href="info.AbsentPic"
            target="_blank"
            v-if="info.CircumstanceStatus>0&&info.AbsentPic"
          >
            <span class></span>
          </a>
        </v-flex>
        <span v-if="info.AllowLeaveCSRemark&&info.CircumstanceStatus===0">N/A</span>
        <v-flex>
          <v-btn
            @click="uploads"
            class="text-none"
            color="error"
            dark
            v-if="([104,105,106,107,108].indexOf(info.CircumstanceStatus)>-1) && (!info.AbsentPic)"
          >
            <v-icon
              dark
              left
            >cloud_upload</v-icon>Student Absence
          </v-btn>
          <v-flex
            v-if="(info.CircumstanceStatus===1||info.CircumstanceStatus===10)&& (!info.AbsentPic)"
          >Note Please upload the screenshot after 15 mins.</v-flex>
          <input
            @change="fileChange"
            accept=".pdf, .doc, .docx, .jpg, .gif, .png, .jpeg"
            ref="file_upload"
            type="file"
            v-show="0"
          />
        </v-flex>
      </v-layout>
      <v-layout
        class="textbook"
        v-show="classStatus === 'finished'"
      >
        <v-flex xs4>TextBook</v-flex>
        <v-flex xs8>
          <span v-if="info.SubjectName !=null && info.SubjectName !=''">{{info.Categoryname}}</span>
          <v-btn
            :title="info.SubjectName !=null && info.SubjectName !='' ? info.SubjectName : info.Categoryname"
            @click="$store.dispatch('downloadFile', {directory: 'TeachingMaterial', path: info.Documents})"
            block
            color="teal"
            dark
            style="max-width: 20em;text-transform:none"
            v-if="info.SubjectName || info.Categoryname"
          >
            <span class="text-truncate">{{info.SubjectName !=null && info.SubjectName !=''? info.UnitLessonSort+' '+info.SubjectName : info.Categoryname}}</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        class="lessonplan"
      >
        <v-flex xs12 v-if="info.AllowLessonPlan!==3">
          <v-layout v-if="info.isVip===0">
            <v-flex xs4>Lesson Plan</v-flex>
            <v-flex xs8>
              <v-btn
                v-if="info.AllowLessonPlan===1"
                @click="$store.commit('classDetail/lessonPlanDialog',{clid:info.CLID,classTime:info.ClassTime})"
                class="text-none blue-button"
                
              >Lesson Plan</v-btn>
              <v-btn
                v-if="info.AllowLessonPlan===2"
                @click="$store.commit('classDetail/lessonPlanDialog',{clid:info.CLID,classStatus,classTime:info.ClassTime})"
                class="text-none"
                color="primary"
              >
                √ Completed
                <v-icon
                  right
                  small
                >border_color</v-icon>
              </v-btn>
              <span v-if="info.AllowLessonPlan===0" class="red-text">Not Filled</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <v-dialog v-model="reminder.dialog" max-width="940" style="{ zIndex: 999; }" :persistent="true">
      <v-card class="px-3 pb-3 pt-0" tyle="color: #32397A;line-height: 22px;">
        <v-card-title class="headline text-xs-center font-weight-bold" primary-title>
          <v-spacer></v-spacer>
          Students' Review ( Postive/ Negative)  for Previous Teachers
          <v-spacer></v-spacer>
          <v-progress-circular :rotate="-90"
                               :size="45"
                               :width="3"
                               :value="reminder.progress"
                               class="body-2 font-weight-bold red--text">
            {{reminder.seconds}}s
          </v-progress-circular>
        </v-card-title>
        <v-card-text>
          <p class="c_title">Favorable comment</p>
          <div class="comment">
                  <v-layout wrap v-if="PositiveList&&PositiveList.length">
                    <v-flex xs12 mb-1 v-for="(item,i) in PositiveList" :key="i"><span>{{item.AppraisalItemInfoEN}}（{{item.Total}}）</span>
                      <v-tooltip v-if="i==0" bottom content-class="commons-tooltip evaluate-tooltip" v-model="showSuggestTip">
                        <template v-slot:activator="{ on }">
                          <img :src="suggest" alt="" v-on="on" class="cursor-pointer" @click="openSuggestFile(item.RedirectUrl,item.Id)" style="vertical-align: middle" />
                        </template>
                        <span>{{item.Suggestion}}<br>
                          More tips on planning the lesson can be found here.</span>
                      </v-tooltip>
                      <v-tooltip v-else bottom content-class="commons-tooltip evaluate-tooltip">
                        <template v-slot:activator="{ on }">
                          <img :src="suggest" alt="" v-on="on" class="cursor-pointer" @click="openSuggestFile(item.RedirectUrl,item.Id)" style="vertical-align: middle" />
                        </template>
                        <span>{{item.Suggestion}}<br>
                          More tips on planning the lesson can be found here.</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                  <p v-else>The students left no reviews for tutors in the past, please well-prepare for your class.</p>
          </div>
          <p class="c_title">Bad review</p>
          <div class="comment">
            <v-layout wrap v-if="NegativeList&&NegativeList.length">
              <v-flex xs12 mb-1 v-for="(item,i) in NegativeList" :key="i"><span>{{item.AppraisalItemInfoEN}}（{{item.Total}}）</span>
                <v-tooltip bottom content-class="commons-tooltip evaluate-tooltip">
                  <template v-slot:activator="{ on }">
                    <img :src="suggest" alt="" v-on="on" class="cursor-pointer" @click="openSuggestFile(item.RedirectUrl,item.Id)" style="vertical-align: middle" />
                  </template>
                  <span>{{item.Suggestion}}<br>
                    More tips on planning the lesson can be found here.</span>
                </v-tooltip>
              </v-flex>
            </v-layout>
            <p v-else>The students left no reviews for tutors in the past, please well-prepare for your class.</p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="#EE344C"
                   class="text-none red-button dialog-submit"
                   style="height: 30px;border-radius: 5px;box-shadow: none;"
                   :disabled="reminder.seconds!==0"
                   @click="agreeProtocol">read</v-btn>
                   <v-btn 
                   class="text-none cancel-button"
                   style="height: 30px;border-radius: 5px;box-shadow: none;color:black !important;"
                   @click="agreeclose">cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <student-Profile :studentProfile="studentProfile"></student-Profile>

    <v-dialog v-model="AIDetail" width="60em">
      <v-card>
        <v-card-text
          class="blue-title px-4 ai-detail-dialog"
          style="overflow-wrap: break-word;"
        >

        <div class="t1">English Level</div>
        <div class="t2">{{ info.CessonAIEnergizeResult && info.CessonAIEnergizeResult.EnglishLevel }}</div>

        <div class="t1">Learning Motivation</div>
        <div class="t2">{{ info.CessonAIEnergizeResult && info.CessonAIEnergizeResult.LearningMotivation }}</div>

        <div class="t1">Hobbies</div>
        <div class="t2">{{ info.CessonAIEnergizeResult && info.CessonAIEnergizeResult.HobbiesAndInterest }}</div>

        <div class="t1">Favorite Teaching Style</div>
        <div class="t2">{{ info.CessonAIEnergizeResult && info.CessonAIEnergizeResult.TeachingMethod }}</div>

        <div class="t1">Teaching Suggestions</div>
        <div class="t2">{{ info.CessonAIEnergizeResult && info.CessonAIEnergizeResult.TeachingAdvice }}</div>

      </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import assistance from './assistanceDialog'
import singleAssistanceDialog from './singleAssistanceDialog'
import classRemark from './classRemark'
import classRemark2 from './classRemarks'
import studentProfile from './studentProfile.vue'
import classRemarkTrial from './classRemarkTrial'
import newClassRemark from './newClassRemark'
import newClassRemarkTrial from './newClassRemarkTrial'  //非VIP试听课 上传知识点数据后的评价弹层 IsShowNewRemark为true
import lessonPlan from './lessonPlan' //备课
import { createNamespacedHelpers } from 'vuex'
import {uploader} from '@/utils/patchUpload'
import {
  EndClass,
  GetUserUserReportByID,
  GetCSPloblemDetails,
  UploadAbsentPic,
  AllowUploadAbsentPic,
  SumbitTheSameMaterials,
  isCurrentUserInPastLabelExperiment,
  getCurrentStudentAppraisalItemSuggestionList,
  insertSuggestClickLog,
  checkCategory,
  InsertStudentAppraisalPopupLog,
  getStuInfoByUID,
  AddTutorEventLog,
  RecordUserBehavior
} from '@/api/classtable.js'
import dateFileter from '@/filters/dateFilter'
import classToolBtn from './classToolBtn'
import textTruncate from '@/filters/textTruncate'
import { _debounce } from '@/utils/tools.js'
import { convertToUnit } from 'vuetify/src/util/helpers'
import { consoleInfo } from 'vuetify/src/util/console';
import { setCookie, getCookie, clearCookie, urlParamsToObject } from '@/utils/tools'
import suggest from '@/assets/img/class/suggest.png'

const namespace = 'classDetail'
const { mapGetters } = createNamespacedHelpers(namespace)
import { formatDate } from '@/utils/date'
export default {
  filters: { dateFileter, textTruncate },
  components: {
    assistance,
    singleAssistanceDialog,
    classRemark,
    classRemark2,
    // eslint-disable-next-line vue/no-unused-components
    classRemarkTrial,
    classToolBtn,
    newClassRemark,
    newClassRemarkTrial,
    lessonPlan,
    studentProfile
  },
  computed: {
    ...mapGetters(['info', 'currentLesson', 'classStatus','lessonPlan']),
    isCanOpens : {
      get(){
        var clickClassOverTime = new Date(this.clickClassOverTime)
        var isCanOpen = new Date(clickClassOverTime.setSeconds(clickClassOverTime.getSeconds() + 90))
        if(new Date() < isCanOpen){
            
          return false
        }
        return true
      }
    }
        
  },
  data () {
    return {
      openAssistance: false,
      openSingleAssistanceDialog: false,
      classRemarkDialog: false,
      // classRemarkTrialDialog: false,
      classInfo: {},
      evidenceFile: {},
      evidence: '',
      overflowDialog: {
        show: false,
        title: '',
        content: ''
      },
      classRemarks2: {
        dialog: false
      },
      newClassRemark: {
        dialog: false
      },
      newClassRemarkTrial: {
        dialog: false
      },
      OverClassLoading: false,
      isShow: false,
      suggest,
      showSuggestTip:true,
      isPastLabelUser:false,
      PositiveList:[],
      NegativeList:[],
      reminder: {
        dialog: false,
        progress: 100,
        seconds: 5,
        timer: null,
        timer1: null
      },
      commtimer: "",
      staytime: 0,
      studentProfile: {
        dialog: false,
        info: "",
        clId: "",
        uid: "",
      },
      stuTimer: null,
      isCanOpen: false,
      clickClassOverTime: localStorage.getItem("tutor_clickClassOverTime"),
      AIDetail: false,
      AIDetailLoading: false
    }
  },
  created(){
    if(!this.isCanOpens){
      var s = setInterval(() => {
        var clickClassOverTime = new Date(this.clickClassOverTime)
        var isCanOpen = new Date(clickClassOverTime.setSeconds(clickClassOverTime.getSeconds() + 90))
        if(new Date() > isCanOpen){
          this.isCanOpen = true
          clearInterval(s)
        }else{
          this.isCanOpen = false
        }
      }, 10000);
    }else{
      this.isCanOpen = true
    }
  },
  methods: {
    studentInfo(id,time,CLID) {
      getStuInfoByUID(id,time).then(r => {
        if (r) {
          var param = {
            title: "classDetail",
            element_content: "学生档案",
            class_id: CLID,
            tuid: this.$store.state.user.tuid
          }
          AddTutorEventLog(1,JSON.stringify(param)).then(r =>{})
          this.studentProfile.dialog=true;
          this.studentProfile.info = r;
          this.studentProfile.clId = this.info.CLID;
          this.studentProfile.uid = id
        }
      })
    },
    countdown () {
      this.reminder.dialog = true
      this.reminder.seconds = 5;
      this.reminder.progress = 100;
      this.reminder.timer = setInterval(() => {
        this.reminder.seconds--;
        if (this.reminder.seconds == 0) {
          this.reminder.seconds = 0;
          this.reminder.progress = 0;
          clearInterval(this.reminder.timer1)
          clearInterval(this.reminder.timer)
          this.reminder.timer = null;
          this.reminder.timer1 = null
          return
        }
      }, 1000)
      this.reminder.timer1 = setInterval(() => {
        this.reminder.progress -= 100 / 20
      }, 200)
    },
    agreeclose() {
      this.reminder.dialog = false;
    InsertStudentAppraisalPopupLog(this.info.CLID,this.staytime,0)
    clearTimeout(this.commtimer);
    },
    agreeProtocol () {
      this.reminder.dialog = false;
    InsertStudentAppraisalPopupLog(this.info.CLID,this.staytime,1)
    clearTimeout(this.commtimer);
    },
    turnToString(arr){
      var text = "";
      arr.forEach((v)=>{
        text += v.Title ? v.Title+":"+v.Content+"<br>" : v.Content+"<br>"
      })
      return text
    },
    successTip (msg) {
      return this.$root.$alertTips(msg, 'success')
    },
    errorTip (msg) {
      return this.$root.$alertTips(msg)
    },
    openImg () {
      window.open(this.info.AbsentPic, '_blank')
    },
    EndClass () {
      this.OverClassLoading = true
      var param = {
        ClassTool: this.info.ClassTools,
        Uid: this.info.StuUID,
        UCID:
          this.info.GetUserCatagory == null
            ? 0
            : this.info.GetUserCatagory.UCID, //
        CLID: this.info.CLID,
        SID:
          this.currentLesson == null ? this.info.SID : this.currentLesson.SID,
        TUID: this.info.TUID,
        ClassTime: this.info.ClassTime
      }
      EndClass(param).then(r => {
        this.OverClassLoading = false
        if (r > 0) {
          localStorage.setItem("tutor_clickClassOverTime", new Date());
          this.$router.go()
        } else if (r === -2) {
          this.errorTip('Invalid Data！')
          // this.$toasted.error('Invalid Data！')
        } else if (r === -11) {
          this.errorTip('Error! Please refresh the page and submit it again')
          //this.$toasted.error(
          //  'Error! Please refresh the page and submit it again'
          //)s
        } else if (r === -3) {
          this.errorTip('Sorry ! The lesson has not begun!')
         // this.$toasted.error('Sorry ! The lesson has not begun!')
        } else if (r === -4) {
          this.errorTip("There's no textbook! Please report to the CS assign the book for the class.")
          //this.$toasted.error(
          //  "There's no textbook! Please report to the CS assign the book for the class."
          //)
        } else if (r === -5) {
          this.errorTip('Sorry ! Submission is ONLY allowed AFTER the class.')
          //this.$toasted.error(
          // 'Sorry ! Submission is ONLY allowed AFTER the class.'
          //)
        } else if (r === -6) {
          this.errorTip('Sorry ! Class time less than 10 minutes.') 
        } else if (r === -7) {
          this.errorTip('Sorry ! Submission is ONLY allowed AFTER the class.') 
        }
        else {
          this.errorTip('System is busy! Please try again later!')
          //this.$toasted.error('System is busy! Please try again later!')
        }
      })
    },
    OpenRemark () {
      if(!this.isCanOpen){
          this.errorTip('AI report is being generated. Please come back after 90 seconds for editing.')
          return
      }
      if (!this.info.IsOverClass || this.info.ShowOverClassBtn) {
        // this.$toasted.error('Please click the“Class Over” button first!')
        return
      }
      this.classRemarks2.dialog = false
      this.classRemarkDialog = false
      // this.classRemarkTrialDialog = false
      this.newClassRemark.dialog = false
      this.newClassRemarkTrial.dialog = false
      if (this.info.isVip === 1) {
        if(this.info.IsShowNewRemark){
            this.newClassRemark.dialog = true
          }
        else if (this.info.NewVipReport) {
            this.classRemarks2.dialog = true
        } else {
          this.classRemarkDialog = true
        }
      } else {
        
        if (this.info.IsShowNewRemark) {
         this.newClassRemarkTrial.dialog = true 
        //  this.classRemarkDialog = true
        }else{
          this.classRemarkDialog = true
          // this.newClassRemarkTrial.dialog = true 
         // this.newClassRemarkTrial.dialog = true
        }
        // if (!this.info.TestTrailReport) {
        //   this.classRemarkDialog = true
        // } else{
        //   this.classRemarkTrialDialog = true
        // }
      }
    },
    getAssistanceInfo () {
      this.openSingleAssistanceDialog = true
    },
    uploads () {
      let isClient = getCookie('client')=='tutorclient'
      let isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if(isClient && isMac){
        //Mac版客户端无法触发文件上传框特殊处理
        let nowTime=this.getBJTime().getTime()
        let classTimeMac = new Date(this.info.ClassTime.replace("T"," ").replace(/-/g, "/")).getTime()
        if(nowTime>classTimeMac+900000){
          this.$refs.file_upload.click()
        }else{
          this.errorTip('Please upload it later. You need to wait for the student 15 mins at least.')
        }
      }else{
        AllowUploadAbsentPic(this.info.CLID).then(res => {
          if (res) {
            this.$refs.file_upload.click()
          } else {
            this.errorTip('Please upload it later. You need to wait for the student 15 mins at least.')
            //this.$toasted.error(
            //  'Please upload it later. You need to wait for the student 15 mins at least.'
            //)
          }
        })
      }
    },
    async fileChange (elemt) {
      this.evidenceFile = elemt.target.files[0]
        var _uploader=new uploader({
            module: "Absent",
            progressbar: this.$root.$progressbar,
        })
        
        let uploadResult = await _uploader.upload(this.evidenceFile)
        if(uploadResult.ErrorCode!=0){
            this.$root.$alert(uploadResult.Msg||'Upload fail.')
            return
        }
        var data = uploadResult.Body
        if(!data){
            return
        }

      let formData = new FormData()
      formData.append('file', data.FileUrl)
      formData.append('Uid', this.info.StuUID)
      formData.append('CLID', this.info.CLID)
      formData.append('SourceName', data.FileName)
      formData.append('FileName', data.FileName)
      UploadAbsentPic(formData).then(res => {
        if (res > 0) {
          this.$router.go()
        } else if (res === -1) {
          this.errorTip('Please upload it later. You need to wait for the student 15 mins at least.')
        }
      })
    },
    // showSpecialRequest () {
    //   const dialog = this.overflowDialog
    //   dialog.title = `Students' Special request`
    //   const content = []
    //   this.info.StudentRequest.forEach(item => {
    //     content.push(
    //       `<p>${item.Title ? item.Title + ':' : ''} ${item.Content}</p>`
    //     )
    //   })
    //   dialog.content = content.join('')
    //   dialog.show = true
    // },
    // showLearningIntention () {
    //   const dialog = this.overflowDialog
    //   dialog.title = `Students' Learning Intention`
    //   const content = []
    //   content.push(`<p>${this.info.Intention || 'N/A'}</p>`)
    //   content.push(`<p>Notes: ${this.info.Csremark || 'N/A'}</p>`)
    //   dialog.content = content.join('')
    //   dialog.show = true
    // },
    timer(dateDiff) {
      return setTimeout(()=>{
        this.isShow=true;
      }, dateDiff)
    },    
    getBJTime() {
      var current_Date = new Date();
      var temp_Hour = current_Date.getHours();
      var time_Zone = -current_Date.getTimezoneOffset() / 60;
      if (time_Zone < 0) {
        time_Zone = Math.abs(time_Zone) + 8;
        current_Date.setHours(temp_Hour + time_Zone);
      } else {
        time_Zone -= 8;
        current_Date.setHours(temp_Hour - time_Zone);
      }
      return current_Date;
    },
    getSameMaterial: _debounce(function () {
      SumbitTheSameMaterials(
        this.info.CLID,
        this.info.TUID,
        this.info.StuUID,
        this.info.ClassTime
      ).then(res => {
        window.location.reload()
        // this.$toasted.error(res.Msg)
      })
    }),
    openSuggestFile(FileUrl,id){
      if (/\.(mp4|MP4)$/.test(FileUrl)) {
        var page = window.open();
        var html=`<body style='background:black'>
            <div style='width:80%;margin:auto;'>
            <video controls width='100%' autoplay src='${FileUrl}'></video> 
            </div>
            </body>`
        page.document.write(html);
      } else if(/\.(pdf|PDF)$/.test(FileUrl)) {
        // pdf 格式
        var client = getCookie("client")
        var isMac = /macintosh|mac os x/i.test(navigator.userAgent);

        if(client=="tutorclient" && isMac && /\.(pdf|PDF)$/.test(FileUrl)){
          var url = `/static/pdf/web/viewer.html?file=${FileUrl}`
          window.open(url, "_blank");
        }else{
          window.open(FileUrl,"_blank");
        }
      }else{
        window.open(FileUrl,"_blank");
      }
      insertSuggestClickLog(this.info.CLID,id)
    },
    pastLabelExperiment(){
      //学生过往好差评实验对象改为所有VIP课程
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      var currentTime = new Date().getTime();
      var classTime = this.info.ClassTime;
      if(isMac){
        classTime = new Date(classTime.replace("T"," ").replace(/-/g, "/")).getTime();
      }else{
        classTime = new Date(classTime).getTime();
      }
      //是VIP课且上课时间还未到则弹框
      if(this.info.isVip === 1 && classTime>currentTime){
          this.countdown();
          this.commtimer = setInterval(this.coss, 1000)
          getCurrentStudentAppraisalItemSuggestionList(this.info.StuUID).then(res=>{
          if(res){
            this.PositiveList = res.PositiveList;
            this.NegativeList = res.NegativeList;
          }
        })
      }
    },
    coss(){
      this.staytime++;
    },
    async showAIDetail(){
      this.AIDetailLoading = true
      await this.behaviorUser(478)
      this.AIDetail = true
      this.AIDetailLoading = false
    },
    formatDate(date){
      return formatDate(date,'MM-dd-yyyy');
    },
    async behaviorUser(labelId){
      const r_data = {
        userId: this.$store.state.user.tuid,
        startTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        endTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        labelId: labelId,
        customData: {
          'CLID': this.info.CLID
        }
      }
      await RecordUserBehavior(r_data).then(res => {
        console.log(res);
      }).catch(err => {
          console.log('请求失败: ' + err.message);
      })
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  watch:{
    info(){
    var param = {
      title: "classDetail",
      class_id: this.info.CLID,
      tuid: this.$store.state.user.tuid,
      show_profile_button: this.info.IsExperimentStu ? 1 : 0
    }
    AddTutorEventLog(4,JSON.stringify(param)).then(r =>{})
      this.pastLabelExperiment();

      var waiting = this.info.Waiting;
      //5 minutes before（300000=5*60*1000）
      if (waiting > 300000) {
        this.timer(waiting);
      } else {
        this.isShow=true;
      }

      //熊出没教材下架提醒老师更换教材
      if(this.info.GetUserCatagory && this.info.GetUserCatagory.CatID>0){
        checkCategory(this.info.GetUserCatagory.CatID,this.info.GetUserCatagory.CategoryName,this.info.StuUID,this.info.ClassTime).then((res)=>{
          if(res){
            this.$root.$alertTips(res, '',{ icon: { default:true } });
          }
        })
      }
    },
    AIDetail (val) {
      if(val === true){
        this.behaviorUser(479)
      }
      if(val === false){
        this.behaviorUser(480)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.grid-table {
  font-size: 1.2em;
  background-color: white;
  display: grid;
  grid-template-columns: 0.69fr 1.4fr 0.6fr 1.4fr;
  // border-top: 1px solid black;
  // border-right: 1px solid black;
  // border-radius: 0.3em;
  box-shadow: 0px 0px 10px rgba(125, 162, 255, 0.19);
  border-radius: 8px;
}
.grid-table--unfinished {
  @include bg_color($background-color-theme);
  @include font_color($font-color-theme);
  // request-content有需求限制显示内容, 因为那玩意是多个P组成的, 只能这边限高6em实现
  grid-template-rows: repeat(6, minmax(3em, auto));
  grid-template-areas:
    "cid cid uid uid-content"
    // "qq qq skype skype-content"
    "time time skype skype-content"
    "tool tool request request-content"
    "remark remark intention intention-content"
    "problem problem-content intention intention-content"
    "lessonplan lessonplan intention intention-content";
}
.grid-table--incorrectFinished {
  @include bg_color($background-color-theme);
  @include font_color($font-color-theme);
  grid-template-rows: repeat(2, 4em) repeat(5, minmax(4em, auto));
  grid-template-areas:
    "cid cid request request-content"
    // "qq qq request request-content"
    "time time problem problem-content"
    "uid uid-content problem problem-content"
    "skype skype-content problem problem-content"
    "tool tool intention intention-content"
    "remark remark intention intention-content"
    "lessonplan lessonplan intention intention-content";
}
.grid-table--finished {
  @include bg_color($background-color-theme);
  @include font_color($font-color-theme);
  grid-template-rows: repeat(2, 3em) repeat(6, minmax(3em, auto));
  grid-template-areas:
    "cid cid request request-content"
    "time time request request-content"
    "uid uid-content problem problem-content"
    "skype skype-content problem problem-content"
    "tool tool problem problem-content"
    "textbook textbook intention intention-content"
    "remark remark intention intention-content"
    "lessonplan lessonplan intention intention-content";
}
.grid-table-evaluate--unfinished{
  @include bg_color($background-color-theme);
  @include font_color($font-color-theme);
  grid-template-rows: repeat(8, minmax(3em, auto));
  grid-template-areas:
    "cid cid positive positive"
    "time time positive positive"
    "uid uid-content positive positive"
    "skype skype-content positive positive"
    "tool tool negative negative"
    "remark remark negative negative"
    "problem problem-content negative negative"
    "lessonplan lessonplan negative negative";
}
.grid-table-evaluate--incorrectFinished{
  @include bg_color($background-color-theme);
  @include font_color($font-color-theme);
  grid-template-rows: repeat(3, 3em) repeat(5, minmax(3em, auto));
  grid-template-areas:
    "cid cid positive positive"
    "time time positive positive"
    "uid uid-content positive positive"
    "skype skype-content positive positive"
    "tool tool negative negative"
    "remark remark negative negative"
    "problem problem-content negative negative"
    "lessonplan lessonplan negative negative";
}
.grid-table-evaluate--finished{
  @include bg_color($background-color-theme);
  @include font_color($font-color-theme);
  grid-template-rows: repeat(3, 3em) repeat(6, minmax(3em, auto));
  grid-template-areas:
    "cid cid positive positive"
    "time time positive positive"
    "uid uid-content positive positive"
    "skype skype-content positive positive"
    "tool tool negative negative"
    "textbook textbook negative negative"
    "remark remark negative negative"
    "problem problem-content negative negative"
    "lessonplan lessonplan negative negative";
}
.grid-table > .layout {
  align-items: center;
  // padding-left: 0.5em;
  padding: 1.5rem 1.5rem;
  border-left: 1px solid rgba(224, 224, 224, 0.5);
  border-bottom: 1px solid rgba(224, 224, 224, 0.5);
  @include font_color($font-color-theme);
  & > .flex:nth-of-type(1) {
    font-weight: bolder;
    
  }
}
.layout [class$="-content"],
[class*="-content"] {
  border-left: none;
}
.class-id {
  grid-area: cid;
}
.uid {
  grid-area: uid;
}
.uid-content {
  grid-area: uid-content;
  padding-left: .8rem!important;
  position: relative;
}
.uid-content .AI-btn{
  position: absolute;
  right: 5rem;
  background: #5fc5d2!important;
  height: 24px;
  border-radius: 4px;
  min-width: 80px !important;
  color: #fff !important;
  box-shadow: none !important;
}
.ai-detail-dialog{
  padding: 2rem;
  .t1{
    font-weight: bold;
    font-size: 16px;
    margin-bottom: .3rem;
  }
  .t2{
    margin-bottom: 1rem;
    font-size: 15px;
    line-height: 1.6;
  }
}
.qq {
  grid-area: qq;
}
.skype {
  grid-area: skype;
}
.skype-content {
  grid-area: skype-content;
  padding-left: .8rem!important;

}
.time {
  grid-area: time;
}
.request {
  grid-area: request;
}
.request-content {
  grid-area: request-content;
  padding-left: .8rem!important;

}
.positive{
  grid-area: positive;
}
.negative{
  grid-area: negative;
}
.tool {
  grid-area: tool;
}
.intention {
  grid-area: intention;
}
.remark {
  grid-area: remark;
}
.problem {
  grid-area: problem;
}
.problem-content {
  grid-area: problem-content;
}
.textbook {
  grid-area: textbook;
}
.lessonplan {
  grid-area: lessonplan;
}
.layout button:first-of-type{
  margin-left: 0;
}
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline){
  background: #9e9e9e!important;
  color: white!important;
}

.info-table-tooltip{
    width:500px;
    word-break: break-all;
    word-wrap: break-word;
    font-size: 14px;
    line-height: 24px;
    background: rgb(176, 179, 200);
    padding: 12px 15px;
  }
  .red-text{
      color: #FF5555;
  }
  .layout.positive,.layout.negative{
    align-items: baseline;
    .layout{
      font-weight: normal;
    }
  }
  .evaluate-tooltip{
    opacity:.95 !important;
  }
  .lessonplan .layout{
    align-items: center;
  }
</style>

<style lang="scss">
.request-content-items {
  width: 100%;
  height: 3em;
  cursor: pointer;
  .v-btn{
    text-align: left;
    height: 100%;
    margin: 0;
    .v-btn__content{
        overflow: hidden;
        height: 100%;
        width: 100%;
        @include font_color($font-color-theme);
        font-size: 1.2rem;
        display: block;
        white-space: normal;
        .line-clamp-2{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          display: -moz-box;
          -moz-line-clamp: 2;
          -moz-box-orient: vertical;
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal; 
        }
    }
  }
  p {
    margin-bottom: -0.2em;
  }
  div {
    position: relative;
    top: 10%;
    overflow: hidden;
    height: 80%;
  }
  &:hover {
    opacity: 0.8;
    transition: 0.2s;
    background: rgba(125, 162, 255, 0.14);;
  }
}
.intention-content {
  grid-area: intention-content;
  padding-left: .8rem!important;
  .v-btn{
    text-align: left;
    height: 100%;
    margin: 0;
    width: 100%;
    padding: 0;
    .v-btn__content{
        overflow: hidden;
        height: 100%;
        width: 100%;
        @include font_color($font-color-theme);
        font-size: 1.2rem;
        display: block;
        white-space: normal;
    }
    &:hover{
      background: rgba(125, 162, 255, 0.14);
    }
  }
  &:hover {
    cursor: pointer;
  }
}
.comment {
  width: 100%;
  height: 150px;
  border: 1px solid slategrey;
  border-radius: 10px;
  padding: 10px 15px;
}
.c_title {
  margin: 16px 0;
}
.remark .grey{
  background: grey!important;
}
.ext-tag{
  padding-right: 10px;
  width: auto!important;
  &::after{
    left: 100%!important;
  }
}

</style>